// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordItemContent_container__2mVjA","topContainer":"KeywordItemContent_topContainer__vhJAc"};